import React, { ReactNode, useEffect } from 'react';
import { Button, Dialog, DialogContent, DialogActions } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setShow403Dialog } from '../../redux/reducer/forbiddenDetectorReducer';
import { setShowSubmitDataError } from '../../redux/reducer/contextIdReducer';
import { RootState, useAppSelector } from '../../redux/Store';
import useImages from '../../components/MainComponent/hooks/useImages';
import { Platform } from '../../constants/platform';
type ForbiddenDialogProps = {
  children: ReactNode;
};
const reloadAllImages = () => {
  const selector = 'img[src*="sgpdev"], img[src*="safeguardproperties"]';
  for (const img of Array.from(
    document.querySelectorAll<HTMLImageElement>(selector)
  )) {
    const url = new URL(img.src, globalThis.location.origin);
    url.searchParams.set('timestamp', Date.now().toString());
    img.src = url.toString();
  }
};

const ForbiddenDialog: React.FC<ForbiddenDialogProps> = ({ children }) => {
  const { fetchImages } = useImages();
  const dispatch = useDispatch();
  const show403Dialog = useAppSelector(
    (state: RootState) => state.forbiddenDetector.show403Dialog
  );
  const handleClose = () => {
    if (Platform?.isAudit()) {
      dispatch(setShowSubmitDataError(false));
    }
    dispatch(setShow403Dialog(false));
    if (Platform?.isAudit()) {
      reloadAllImages();
    }
  };

  return (
    <Dialog open={show403Dialog}>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button variant='contained' color='primary' onClick={handleClose}>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ForbiddenDialog;
